export default __webpack_public_path__ + "static/media/andes_a_la_costa_15.9b4cf682.JPG";